<template>
  <div>
    <vx-card class="p-4 mb-6">
      <div class="flex flex-wrap items-center justify-between mb-4">
        <div class="flex items-center ml-1">
          <h4>Monitoring</h4>
        </div>
        <vs-button @click="fetchData" icon="refresh" :disabled="isLoading">Refresh</vs-button>
      </div>

      <div class="mb-4 w-full md:w-1/3">
        <label class="vs-input--label">Select Warehouse</label>
        <vs-select
          class="selectExample w-full"
          v-model="warehouse_id"
          autocomplete
          @change="fetchData"
          width="100%"
        >
          <vs-select-item value="" text="All Warehouses" />
          <vs-select-item
            v-for="(item, index) in warehouses"
            :key="index"
            :value="item.id"
            :text="item.warehouses_code"
          />
        </vs-select>
      </div>

      <vs-table :data="tableData" stripe hoverFlat>
        <template slot="thead">
          <vs-th>Tanggal</vs-th>
          <vs-th>Product Code</vs-th>
          <vs-th>Warehouse</vs-th>
          <vs-th>Inbound Qty</vs-th>
          <vs-th>Outbound Qty</vs-th>
          <vs-th>Inventory Qty</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :key="index" v-for="(tr, index) in data">
            <vs-td>{{ tr.date ? $moment(tr.date).format('DD MMM YYYY') : '-' }}</vs-td>
            <vs-td>{{ tr.product ? tr.product.product_code : '-' }}</vs-td>
            <vs-td>{{ tr.warehouse ? tr.warehouse.name : '-' }}</vs-td>
            <vs-td>{{ tr.inbound_qty }}</vs-td>
            <vs-td>{{ tr.outbound_qty }}</vs-td>
            <vs-td>{{ tr.inventory_qty }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination class="mt-4" :total="totalPage" v-model="currentPage" @change="fetchData"></vs-pagination>
    </vx-card>
  </div>
</template>

<script>
export default {
  name: "Monitoring",
  data() {
    return {
      isLoading: false,
      warehouse_id: "",
      warehouses: [],
      tableData: [],
      currentPage: 1,
      totalPage: 1,
      limit: 10,
      loadingCount: 0
    };
  },
  watch: {
    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    }
  },
  mounted() {
    this.fetchWarehouses();
    this.fetchData();
  },
  methods: {
    setLoading(isStart) {
      if (isStart) {
        this.loadingCount += 1;
      } else {
        this.loadingCount = Math.max(0, this.loadingCount - 1);
      }
      this.isLoading = this.loadingCount > 0;
    },
    async fetchWarehouses() {
        this.setLoading(true);
        try {
            const response = await this.$http.post("/master/warehouses", {});
            this.warehouses = response.data.data;
        } catch (error) {
            this.handleError(error);
        } finally {
            this.setLoading(false);
        }
    },
    async fetchData() {
      this.setLoading(true);
      try {
        const response = await this.$http.get("/tvd/monitoring/inventory", {
          params: {
            warehouse_id: this.warehouse_id,
            page: this.currentPage,
            limit: this.limit
          }
        });
        this.tableData = response.data.data;
        this.totalPage = response.data.last_page;
      } catch (error) {
        this.handleError(error);
      } finally {
        this.setLoading(false);
      }
    }
  }
};
</script>
